import {SET_LINEUP_ORDER} from 'src/pages/localChannelLineup/store/actions/setLineupOrder';
import {ASC} from 'src/pages/localChannelLineup/constants/lineupOrder';

export const lineupOrder = (state = ASC, {type, value} = {}) => {
  switch (type) {
    case SET_LINEUP_ORDER:
      return value.lineupOrder;
    default:
      return state;
  }
};
